import React from 'react';
import { useDispatch } from 'react-redux';
import './menu.css';
import { motion } from 'framer-motion';
import { NavLink, useLocation } from 'react-router-dom';
import { setMenuVisible } from '../../features/dialogControl/dialogControlSlice';

const navData = [
    {
        label:"HOME",
        url: "/"
    },
    {
        label:"TRACKS",
        url: "/tracks"
    },
    {
        label:"ARTISTS",
        url: "/artists"
    },
    {
        label:"VOICE",
        url: "/voice"
    },
]

const Menu = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const handleNavClick = () => {
        dispatch(setMenuVisible(false));
    }

    return (
        <motion.div
            className="menu-container"
            initial={{ x: "100vw" }}  
            animate={{ x: 0 }}  
            exit={{ x: "100vw" }}  
            transition={{ duration: 0.35, ease: "easeInOut" }}  
        >
            {navData.map((n,index) => {
                return (
                    <motion.div
                        initial={{ opacity: 0, y: "40px" }}  
                        animate={{ opacity: 1, y: 0 }}  
                        transition={{ duration: 0.5, ease: "easeInOut", delay: (index+1) * 0.1 }} 
                        key={n.url} 
                    >
                        <NavLink 
                            className={`nav-link ${location.pathname === n.url ? 'nav-selected' : '' }`}
                            to={n.url}
                            onClick={() => handleNavClick()}
                            style={{margin: '0px'}}
                        >
                            <div className='menu-nav-link'>{n.label}</div>
                        </NavLink>
                    </motion.div> 
                )
            })}
        </motion.div>
    );
}

export default Menu;